export { PMTAdsense } from './PMTAdsense';
